
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><div className='title'>Renseignements techniques</div>
<MDXTag name="p" components={components}>{`Les cartes de dangers naturels des cantons ont été acquises par notre équipe de datajournalistes sous forme numérique, puis réunie dans une forme unique. Ces cartes sont aussi accessibles sur les différents portails cantonaux. Elles y sont parfois plus complètes, indiquant des dangers supplémentaires (glissement de terrain ou chute de pierres) ou les risques existant dans des zones inhabitées. Les cartes cantonales officielles font seules foi. Les liens vers ces cartes figurent ci-dessous, dans le tableau indiquant la source de nos données. Y figure aussi date à laquelle nous avons acquis ces données. La carte figurant sur ce site ne sera pas mise à jour.`}</MDXTag>
<MDXTag name="p" components={components}>{`Dans les cantons de Soleure, Jura, Zoug, Tessin et Grisons, certains territoires n’ont pas encore été cartographiés. Ces zones manquantes sont visibles sur le site de `}<a href='https://www.bafu.admin.ch/bafu/fr/home/themes/dangers-naturels/info-specialistes/situation-de-danger-et-utilisation-du-territoire/donnees-de-base-sur-les-dangers/cartes-de-dangers--cartes-d-intensite-et-cartes-indicatives-des-.html'>{`l’Office fédéral de l’environnement`}</a>{`.`}</MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  